import React, { useState } from 'react';

import { EXAM_STUDENT_STATES } from 'utils/Constants';

import Show from 'components/Show';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button, Datepicker, Input, Select } from 'components/Misc/Form';

const Search = ({ search, onChange }) => {
	// Store search expanded state
	const [expanded, setExpanded] = useState(false);

	// Handle expand toggle
	const onExpand = () => setExpanded(e => !e);

	return (
		<Container className="mt-4 p-4 flex flex-col space-y-4">
			<div className="flex items-end space-x-2">
				<Input
					type="text"
					name="name"
					label="Meklēt"
					placeholder="Vārds, Uzvārds"
					className="flex-1"
					value={search.name}
					onChange={onChange}
				/>

				<Button
					square
					icon={expanded ? 'keyboard_double_arrow_up' : 'keyboard_double_arrow_down'}
					onClick={onExpand}
				/>
			</div>

			<div className="empty:hidden space-y-4 animate-fade-in">
				<Show if={expanded}>
					<Title
						title="Moduļa parametri"
					/>

					<div className="flex space-x-2">
						<Datepicker
							asInput
							label="Sākuma datums"
							name="courseStartDate"
							value={search.courseStartDate}
							onChange={onChange}
						/>

						<Datepicker
							end
							asInput
							label="Beigu datums"
							name="courseEndDate"
							value={search.courseEndDate}
							onChange={onChange}
						/>
					</div>

					<Title
						title="Pārbaudes darbu parametri"
					/>

					<div className="flex space-x-2">
						<Datepicker
							asInput
							label="Sākuma datums"
							name="examStartDate"
							value={search.examStartDate}
							onChange={onChange}
						/>

						<Datepicker
							end
							asInput
							label="Beigu datums"
							name="examEndDate"
							value={search.examEndDate}
							onChange={onChange}
						/>
				
						<Select
							name="examState"
							label="Statuss"
							placeholder="Ieskaites statuss"
							value={search.examState}
							onChange={onChange}
							options={EXAM_STUDENT_STATES.map(state => ({
								value: state.value,
								name: state.text
							}))}
						/>

						<Input
							name="examMark"
							label="Atzīme"
							placeholder="Atzīme"
							value={search.examMark}
							onChange={onChange}
						/>
					</div>
				</Show>
			</div>
		</Container>
	);
};

export default Search;